import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/students")({
	component: StudentsLayout,
});

function StudentsLayout() {
	return <Outlet />;
}
